var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('flexible-content'),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.showContent)?_c('the-footer'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }